import { SVGProps, Ref, forwardRef } from 'react';

export const HrBrandOutlinedCircledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M12.278 4.805a4.4 4.4 0 0 0 1.78 4.375 4.55 4.55 0 0 0 4.772.317z" fill="currentColor" />
            <path d="M19 10.016c-1.656.222-3.12 1.35-3.67 3.021a4.39 4.39 0 0 0 1.168 4.571z" fill="currentColor" />
            <path d="M7.95 17.93A4.5 4.5 0 0 1 12 15.42a4.5 4.5 0 0 1 4.05 2.509z" fill="currentColor" />
            <path
                d="M8.67 13.038a4.39 4.39 0 0 1-1.168 4.57L5 10.017c1.656.222 3.12 1.35 3.67 3.021"
                fill="currentColor"
            />
            <path d="M9.942 9.18a4.55 4.55 0 0 1-4.771.317l6.552-4.692A4.4 4.4 0 0 1 9.942 9.18" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1M4.789 5.59C3.424 7.228 2.8 9.517 2.8 12s.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2s5.894-1.21 7.211-2.79C20.576 16.772 21.2 14.483 21.2 12s-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8S6.106 4.01 4.789 5.59"
                fill="currentColor"
            />
        </svg>
    )
);
HrBrandOutlinedCircledSize24Glyph.displayName = 'HrBrandOutlinedCircledSize24Glyph';
